import styled, { css } from 'styled-components';
import { Clickable as JourneysClickable } from '@sparknz/journeys-common';
import { getResponsiveSpacing, Spacing } from '@sparknz/spark-pattern-library';

interface ClickableProps {
  ml?: Spacing | Spacing[];
}

const Clickable = styled(JourneysClickable)<ClickableProps>`
  ${({
    theme: {
      spacing,
      palette: { baseColors },
    },
    ml,
  }) => css`
    margin-left: ${ml ? getResponsiveSpacing(ml) : spacing.s0_5};
    vertical-align: bottom;

    &&:focus-visible {
      outline: 2px solid ${baseColors.lupin};
    }
  `}
`;

export default Clickable;
